import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { alertsDashboardStoreSelector } from '../alertsDashboard.selector';

export const isAlertsPollingEnabledSelector = createCachedSelector(
  [
    path(alertsDashboardStoreSelector).isPollingEnabled(),
  ],
  (isPollingEnabled) => {
    return isPollingEnabled;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
